// Pure formatting helpers.

export function timeAgo(ms: number | null | undefined): string {
  if (!ms) return "";
  const s = Math.round((Date.now() - ms) / 1000);
  if (s < 0 && s > -3600) return "in " + duration(-s * 1000);
  const abs = Math.abs(s);
  if (abs < 45) return "just now";
  const units: Array<[number, string]> = [[60, "minute"], [3600, "hour"], [86400, "day"], [2592000, "month"], [31536000, "year"]];
  const [sec, name] = units.findLast(([sec]) => abs >= sec) ?? units[0];
  const n = Math.max(1, Math.round(abs / sec));
  const span = `${n} ${name}${n === 1 ? "" : "s"}`;
  return s < 0 ? `in ${span}` : `${span} ago`;
}

export function duration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return "";
  if (ms < 1000) return `${ms}ms`;
  const s = ms / 1000;
  if (s < 60) return `${s.toFixed(1)}s`;
  const t = Math.round(s);
  const m = Math.floor(t / 60);
  if (m < 60) return `${m}m ${t % 60}s`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ${m % 60}m`;
  return `${Math.floor(h / 24)}d ${h % 24}h`;
}

export const short = (sha: string | null | undefined, n = 10) => (sha ? sha.slice(0, n) : "");

export function bytes(n: number): string {
  if (n < 1024) return `${n} B`;
  const units = ["KiB", "MiB", "GiB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(1)} ${units[i]}`;
}

/** The host of an https://, ssh:// or scp-style (git@host:path) clone URL. */
export function cloneHost(url: string): string | null {
  const scp = /^[^@/\s]+@([^:/\s]+):/.exec(url);
  if (scp) return scp[1].toLowerCase();
  try {
    return new URL(url).hostname.toLowerCase() || null;
  } catch {
    return null;
  }
}

/** "Name <email> 1700000000 +0000" → parts. */
export function parseSig(sig: string): { name: string; email: string; time: number } {
  const m = /^(.*?) <([^>]*)> (\d+)/.exec(sig);
  return m ? { name: m[1], email: m[2], time: Number(m[3]) * 1000 } : { name: sig, email: "", time: 0 };
}

export function messageBody(message: string): string {
  const i = message.indexOf("\n");
  return i < 0 ? "" : message.slice(i + 1).trim();
}

export function safeJson(s: string | null | undefined): unknown {
  if (!s) return null;
  try {
    return JSON.parse(s);
  } catch {
    return s;
  }
}
